import { useEffect } from "react";
import { useTransitionState } from "react-transition-state";

const DrawerModal = ({
    open = false,
    children,
    onClose,
    extraClasses = {},
}) => {
    const [{ status, isMounted }, toggle] = useTransitionState({
        timeout: 300,
        mountOnEnter: true,
        unmountOnExit: true,
        preEnter: true,
    });

    useEffect(() => {
        toggle(!!open);
    }, [open, toggle]);

    const mapStatusClasses = (s) => {
        if (!s) return "";
        const classes = [s];
        if (s === "preEnter") classes.push("preEnter");
        if (s === "entering") classes.push("enter");
        if (s === "entered") classes.push("enter-done");
        if (s === "preExit" || s === "exiting") classes.push("exit");
        if (s === "exited") classes.push("exit-done");
        return classes.join(" ").trim();
    };

    const closeAction = () => {
        toggle(false);
        onClose && onClose();
    };

    if (!isMounted) return null;

    return (
        <div
            className={`drawer-modal ${extraClasses?.modal || ""} ${mapStatusClasses(status)}`}
        >
            <div className="drawer-modal__container">
                <button
                    type="button"
                    className="drawer-modal__close"
                    onClick={closeAction}
                    title="Fermer la modale"
                >
                    <i className="vnf-icons-icon-m-croix-fermer-outline" />
                </button>

                <div className="drawer-modal__content-outer">
                    <div
                        className={`drawer-modal__content-inner ${extraClasses?.content || ""}`}
                    >
                        {children}
                    </div>
                </div>
            </div>

            <div className="drawer-modal__overlay" onClick={closeAction} />
        </div>
    );
};

export default DrawerModal;
